import './reset.css';

import React from 'react';

import { Firebase } from './firebase';
import { LoggedInRoutes, LoggedOutRoutes } from './routes';

export type User = {
  uid: string;
  name: string;
  sid: string;
};

export const AppContext = React.createContext<User>({
  uid: '',
  name: '',
  sid: '',
});

export const App: React.FC = () => {
  const [loading, setLoading] = React.useState(true);
  const [isLoggedIn, setIsLoggedIn] = React.useState(false);
  const [admin, setAdmin] = React.useState(false);

  const [user, setUser] = React.useState<User>({
    uid: '',
    name: '',
    sid: '',
  });

  React.useEffect(() => {
    Firebase.auth.onAuthStateChanged(async (user) => {
      if (user) {
        const { uid } = user;

        const sid = window.localStorage.getItem('sidForSignIn');
        const name = window.localStorage.getItem('nameForSignIn');

        window.localStorage.removeItem('sidForSignIn');
        window.localStorage.removeItem('nameForSignIn');

        if (sid && name) {
          await Firebase.createUser(uid, sid, name);
        }

        const _user = await Firebase.getUser(uid);

        setUser({
          uid,
          name: _user?.name!,
          sid: _user?.sid!,
        });

        setIsLoggedIn(true);
        if (user.email === 'admin@yonseimed.com') {
          setAdmin(true);
        }
      } else {
        setIsLoggedIn(false);
      }

      setLoading(false);
    });
  }, []);

  if (loading) return null;

  return isLoggedIn ? (
    <AppContext.Provider value={user}>
      <LoggedInRoutes admin={admin} />{' '}
    </AppContext.Provider>
  ) : (
    <LoggedOutRoutes />
  );
};
